export default __webpack_public_path__ + "static/media/2.2836a39d.jpg";